<template>
  <button :class="[`btn mat pull-left mr-20`, buttonTypeClass]" @click="$router.go(-1)">
    <slot name="icon"></slot>
    <slot>Back</slot>
  </button>
</template>
<script>
export default {

  name: "back-button",

  props: {
    buttonTypeClass: {
      type: String,
      default: function() {
        return 'btn-primary'
      }
    }
  }

}
</script>
